// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleImage_wrapper__v5EW_","disabled":"ArticleImage_disabled__eQiaG","tag":"ArticleImage_tag__LfuE8","noImage":"ArticleImage_noImage__IZ70U"};